module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_9006.f4cd2d62.png";